// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1gLee","content":"LoadingAlert_content__1YGzM"};